const initialState = {
    balance: ''
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'BALANCE':
            return { ...state, balance: action.payload }                                    
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/balanceReducer.js